<template>
  <div class="right-card">
    <div style="position: absolute;width: 6.5vw;height: 1vw;line-height:1vw;top:10.2vw;left:3.7vw;font-size: 0.8vw;font-family: test;color: white;font-weight: 600;white-space: nowrap">
      拓展实验
    </div>
    <div class="list">
      <div v-for="(item,index) in tabList">
        <div class="tab-line"  @click="toNew(item)">{{item.name}}</div>
        <div class="under-line" v-if="index!==tabList.length-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabRight',
  props:['subject'],
  data(){
    return{
      tabList:[
        {name:'元素周期表',uri:'https://data.xiyilab.com/apps/webgl/%E5%90%8C%E6%AD%A5%E5%AE%9E%E9%AA%8C/%E4%BA%BA%E6%95%99%E7%89%88/%E5%8C%96%E5%AD%A6/%E5%85%83%E7%B4%A0%E5%91%A8%E6%9C%9F%E8%A1%A8/Build/%E5%85%83%E7%B4%A0%E5%91%A8%E6%9C%9F%E8%A1%A8.json',active:false,subject:'化学'},
        {name:'家庭电路',uri:'',active:false,subject:'物理'},
        {name:'显微镜',uri:'',active:false,subject:'生物'},
        {name:'器材库',uri:'https://data.xiyilab.com/apps/webgl/%E5%90%8C%E6%AD%A5%E5%AE%9E%E9%AA%8C/%E4%BA%BA%E6%95%99%E7%89%88/%E5%99%A8%E6%9D%90%E5%BA%93/Build/%E5%99%A8%E6%9D%90%E5%BA%93.json',active:false,subject:'化学'},
      ]
    }
  },
  methods:{
    toNew(item){
      console.log(item)

      let url=this.$router.resolve({
        path: '/webGL',
        query: {
          name:item.name,
          app_uri:item.uri,
          platform:'webgl',
          app_platform_id: 1,
          app_id: 1,
          mode: 4,
          publisher: '',
          grade: '',
          subject: '',
          chapter: ''
        }
      })
      if(item.uri==''){
        this.$message.warning('开发中，敬请期待')
      }
      else{
        window.open(url.href,'_blank')
      }

    }
  }
}
</script>

<style scoped>
.list{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  white-space: nowrap;
  position: absolute;
  top:14vw;
  left:2.8vw;
}
.tab-line{

  height: 1.5vw;
  width: 5vw;
  min-width: 60px;
  text-align: center;
  font-size: 0.7vw;
  cursor: pointer;
  border-radius: 4px;
  color:rgb(24, 122, 255);
  background-color: white;
  font-family: test;
  line-height: 1.5vw;
  font-weight: 600;
}
.tab-line:hover{
  background-color: rgb(94, 178, 247 );
  color: white;
}
.under-line{
  min-width: 60px;
  margin-bottom: 0.2vw;
  margin-top: 0.2vw;
  background-image: url("http://data.xiyilab.com/web/main/static/app/分割线.png");
  width: 5vw;
  height: 2px;
  background-position: center;
  background-size: cover ;
  background-repeat: no-repeat;
}
.right-card{
  min-width: 105px;
  background-image: url("http://data.xiyilab.com/web/main/static/app/特色实验bg.png");
  width: 10vw;
  height: 30vw;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
